import React from 'react';
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Header from "../../Layouts/Header";
import "react-multi-date-picker/styles/layouts/mobile.css"


import {
    MdAddLocation, MdCalendarMonth,
    MdNotListedLocation, MdOutlineDescription,
    MdOutlineRadioButtonChecked,
    MdOutlineRadioButtonUnchecked
} from "react-icons/md";

import DatePicker, {DateObject} from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"


import {ImCheckmark} from "react-icons/im";
import {useNavigate} from "react-router-dom";


const currencyFormat = Intl.NumberFormat('en-US');
function SetRequestOptions(props) {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [addresses, setAddresses] = React.useState([]);
    const [addressId, setAddressId] = React.useState(0);
    const [returnAddressId, setReturnAddressId] = React.useState(0);
    const [diffReturnAddress, setDiffReturnAddress] = React.useState(0);
    const [description, setDescription] = React.useState('');
    const [date, setDate] = React.useState(new DateObject({ calendar: persian }).add(1, "days"))

    const totalPrice = window.localStorage.getItem("totalPrice");
    const companyName = window.localStorage.getItem("companyName");
    const count = JSON.parse(window.localStorage.getItem("cart")).length;


    React.useEffect(() => {
        const params = {
            count: 15,
            page: 1,
            list: 1
        }

        API.getAddresses(params)
            .then((response) => {
                setAddresses(response.data);
                setIsLoaded(true);
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });


    }, []);

    const onStoreRequest = () => {
        const services = JSON.parse(window.localStorage.getItem("cart"));
        const request = {
            company_id : window.localStorage.getItem("companyID"),
            address_id : addressId,
            done_address_id: returnAddressId,
            doing_date: date?.toDate?.().getFullYear() + '-' + date?.toDate?.().getMonth() + '-' +date?.toDate?.().getDate(),
            user_description: description,
            services
        }
        API.storeRequest(request)
            .then((response) => {
                toast.success(response.message);
                window.localStorage.clear();
                setTimeout (() => {
                    window.location.replace(`/requests/${response.data.id}`);
                },1500)
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
    }


    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <Header title='تنظیم مشخصات درخواست' hasBack={true} />

            <section className="container-fluid  mt-3 py-5 rtl px-0 address-box  ">
                <div className="row mx-2 mb-3">
                    <div className="col-6 text-small-3 fw-bold text-dark">
                        <MdNotListedLocation className='ms-2' />
                        انتخاب آدرس مراجعه:
                    </div>
                    <div className="col-6 text-start text-small-3 text-primary-color"
                    onClick={() => navigate('/add-address')}
                    >
                        <MdAddLocation className='ms-2'  />
                        افزودن آدرس جدید

                    </div>
                </div>
                    {
                        isLoaded &&
                        addresses.map (address => {
                            if(address.id === addressId) {
                                return (
                                    <div className="row mx-3 address-row-selected"
                                         onClick={() => setAddressId(address.id)}
                                    >
                                        <div className="col-1">
                                            <MdOutlineRadioButtonChecked className='text-success' />
                                        </div>
                                        <div className="col-11">
                                            <b>
                                                {address.title}
                                                :
                                            </b>
                                            &nbsp;
                                            {address.address}
                                        </div>
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div className="row mx-3 address-row"
                                         onClick={() => setAddressId(address.id)}
                                    >
                                        <div className="col-1">
                                            <MdOutlineRadioButtonUnchecked className='text-muted' />
                                        </div>
                                        <div className="col-11">
                                            <b>
                                                {address.title}
                                                :
                                            </b>
                                            &nbsp;
                                            {address.address}
                                        </div>
                                    </div>
                                )
                            }

                        })

                    }

            </section>
            <section className="container-fluid  mt-0 pb-5 rtl px-0  ">
                <div className="row mx-2 mb-3">
                    <div className="col-5 text-small-3 fw-bold text-dark">
                        <MdCalendarMonth className='ms-2' />
                        انتخاب تاریخ مراجعه:
                    </div>
                    <div className="col-7">
                        <DatePicker
                            defaultValue={date}
                            onChange={ (val) => setDate(val) }
                            minDate={new DateObject({ calendar: persian }).add(1, "days")}
                            maxDate={new DateObject({ calendar: persian }).add(5, "days")}
                            calendar={persian}
                            locale={persian_fa}
                            calendarPosition= "bottom-right"
                            readonly={true}
                            className="rmdp-mobile"

                        />

                    </div>
                </div>
            </section>

            <section className="container-fluid  mt-0 pb-5 rtl px-0  ">
                <div className="row mx-2 mb-3">
                    <div className="col-5 text-small-3 fw-bold text-dark">
                        <MdOutlineDescription className='ms-2' />
                        توضیحات (اختیاری):
                    </div>
                    <div className="col-12 mt-3">
                        <div className="form-floating">
                            <textarea className="form-control"
                                      placeholder="توضیحات"
                                      id="floatingTextarea"
                                      rows={4}
                                      value={description}
                                      onChange={(val) => {
                                          setDescription(val.target.value)
                                      }}
                            >

                            </textarea>
                            <label htmlFor="floatingTextarea" className='text-small-3'>
                                در صورت نیاز به ثبت توضیحات اضافه
                            </label>
                        </div>

                    </div>
                </div>
            </section>

            <section className="container-fluid  mt-0 pb-5 mb-5 rtl px-0  ">
                <div className="row mx-2 mb-5 pb-5">
                    <div className="col-12 text-small-3 fw-bold text-dark">
                        <MdNotListedLocation className='ms-2' />
                        انتخاب آدرس برگشت (اختیاری):
                    </div>
                    <div className="col-12 mt-4">
                        <div className="custom-control ">

                            <input type="checkbox"
                                   className="custom-control-input" id="returnAddress"
                                   placeholder=""
                                   checked={diffReturnAddress}
                                   value = {1}
                                   onChange={
                                       () => {
                                           setDiffReturnAddress(1- diffReturnAddress);
                                           if(diffReturnAddress > 0) setReturnAddressId(0)

                                       }
                                   }

                            />
                            &nbsp; &nbsp;
                            <label htmlFor="returnAddress"  className="custom-control-label text-small-2 text-muted">
                                آدرس برگشت متفاوت است
                            </label>

                        </div>

                    </div>
                    {
                        !diffReturnAddress &&
                        <div className="col-12 text-small-3 text-muted text-justify pt-2">
                            برای خدماتی نظیر قالیشویی اگر می خواهید فرش شسته شده در محلی دیگر غیر از آدرس مراجعه تحویل شما شود این گزینه را انتخاب کنید و آدرس جدید خود را انتخاب کنید.
                        </div>
                    }
                    {
                        diffReturnAddress >0 &&
                        <div className="col-12 text-small-1 text-muted text-justify pt-2 address-box">
                            {
                                isLoaded &&
                                addresses.map (address => {
                                    if(address.id === returnAddressId) {
                                        return (
                                            <div className="row mx-3 address-row-selected"
                                                 onClick={() => setReturnAddressId(address.id)}
                                            >
                                                <div className="col-1">
                                                    <MdOutlineRadioButtonChecked className='text-success' />
                                                </div>
                                                <div className="col-11">
                                                    <b>
                                                        {address.title}
                                                        :
                                                    </b>
                                                    &nbsp;
                                                    {address.address}
                                                </div>
                                            </div>
                                        )
                                    }
                                    else {
                                        return (
                                            <div className="row mx-3 address-row"
                                                 onClick={() => setReturnAddressId(address.id)}
                                            >
                                                <div className="col-1">
                                                    <MdOutlineRadioButtonUnchecked className='text-muted' />
                                                </div>
                                                <div className="col-11">
                                                    <b>
                                                        {address.title}
                                                        :
                                                    </b>
                                                    &nbsp;
                                                    {address.address}
                                                </div>
                                            </div>
                                        )
                                    }

                                })

                            }
                        </div>
                    }


                </div>
            </section>

             <section className="container-fluid rtl ">
                 <div className="row">
                     <div className="col-12 p-2 fixed-bottom max-w-lg px-2 bg-light">
                         <div className='row small-factor'>
                             <div className="col-4 title">تعداد خدمت انتخابی</div>
                             <div className="col-4 title">مجموعه انتخابی</div>
                             <div className="col-4 title">مبلغ</div>
                             <div className="col-4 cell">{count}</div>
                             <div className="col-4 cell">{companyName}</div>
                             <div className="col-4 cell">{currencyFormat.format(totalPrice)} &nbsp; ریال </div>

                         </div>
                         <button
                             className="btn btn-success text-center text-small-1 text-semi-big  w-100 p-2  pr-4 border-0"
                             onClick={onStoreRequest}
                         >
                             ثبت درخواست
                             <span className="badge  p-2 float-start">
<ImCheckmark className='text-big-3' />
                    </span>
                         </button>
                     </div>
                 </div>
             </section>
        </React.Fragment>

    );
}

export default SetRequestOptions;
